<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col cols="12">
				<material-chart-card :color="chart.color" :data="chart.data" :options="chart.options" :responsive-options="chart.responsiveOptions" :title="chart.title" :type="chart.type">
					<template #subtitle>
						<div class="font-weight-light text--secondary">
							<div v-html="chart.subtitle" />
						</div>
					</template>
				</material-chart-card>
			</v-col>
		</v-row>

		<v-row class="mb-6">
			<v-col cols="12" md="6" class="pa-0 ma-0">
				<v-row class="pa-0 ma-0">
					<v-col cols="12">
						<v-card class="px-3">
							<div style="padding:10px 5px;border-bottom: 1px dashed #ddd;" class="">لینک بازاریابی و تبلیغات طرح ها:</div>
							<div v-if="loadingPlans" class="pa-3 text-center success--text">در حال دریافت اطلاعات...</div>
							<div v-else v-for="plan in plans" :key="plan.id" class="pa-2" style="border-bottom: 1px dashed #ddd;">
								<div class="text-center">{{ plan.title }}</div>
								<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
									<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
										<v-icon color="white">mdi-content-copy</v-icon>
									</v-btn>
									<span style="cursor: pointer;" class="info--text" @click="copyToClipborad(plan)">{{ getLink(plan) }}</span>
								</div>
							</div>
							<div v-if="!loadingPlans">
								<div class="text-center">لینک به صفحه اصلی</div>
								<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
									<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
										<v-icon color="white">mdi-content-copy</v-icon>
									</v-btn>
									<span style="cursor: pointer;" class="info--text" @click="copyToClipborad()">{{ getLink() }}</span>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="6" class="pa-0 ma-0">
				<v-row class="pa-0 ma-0">
					<v-col cols="12" md="12">
						<v-card class="px-3">
							<div style="padding:10px 5px;border-bottom: 1px dashed #ddd;" class="">درصد پورسانت شما:</div>
							<div class="text-center pa-2 text-h3 info--text" style="">
								{{ commissionPercent }} درصد
							</div>
						</v-card>
					</v-col>

					<v-col cols="12" md="12">
						<material-stat-card v-bind="stats.register">
							<template #actions>
								<v-icon class="mr-2" small> {{stats.register.actionIcon}} </v-icon>
								<div class="text-truncate" v-html="stats.register.actionText" />
							</template>
							<div class="text-right">
								<v-row class="mx-0 px-3">
									<v-col cols="6" class="d-flex px-0">
										<div class="d-flex align-center">
											<v-btn fab color="rgb(195 237 194)" elevation="0" small class="" dark>
												<v-icon color="success">mdi-check</v-icon>
											</v-btn>
										</div>
										<div class="pr-3">
											<div class="text-h3">{{ stats.register.reffererCount }}</div>
											<div class="text-h6 grey--text">تعداد کل ارجاعی</div>
										</div>
									</v-col>
									<v-col cols="6" class="d-flex px-0">
										<v-btn fab color="rgb(195 237 194)" elevation="0" small class="" dark>
											<v-icon color="success">mdi-check</v-icon>
										</v-btn>
										<div class="pr-3">
											<div class="text-h3">{{ stats.register.registerCount }}</div>
											<div class="text-h6 grey--text">منتهی به ثبت نام</div>
										</div>
									</v-col>
									<v-col cols="6" class="d-flex px-0">
										<v-btn fab color="rgb(195 237 194)" elevation="0" small class="" dark>
											<v-icon color="success">mdi-check</v-icon>
										</v-btn>
										<div class="pr-3">
											<div class="text-h3">{{ stats.register.loanRequstCounts }}</div>
											<div class="text-h6 grey--text">منتهی به درخواست وام</div>
										</div>
									</v-col>
									<v-col cols="6" class="d-flex px-0">
										<v-btn fab color="rgb(195 237 194)" elevation="0" small class="" dark>
											<v-icon color="success">mdi-check</v-icon>
										</v-btn>
										<div class="pr-3">
											<div class="text-h3">{{ stats.register.userLoanCounts }}</div>
											<div class="text-h6 grey--text">منتهی به پرداخت وام</div>
										</div>
									</v-col>
								</v-row>
							</div>
						</material-stat-card>
					</v-col>

					<v-col cols="12" md="12">
						<material-stat-card v-bind="stats.financial">
							<template #actions>
								<v-icon class="mr-2" small> {{stats.financial.actionIcon}} </v-icon>
								<div class="text-truncate" v-html="stats.financial.actionText" />
							</template>
							<div class="text-right">
								<v-row class="mx-0 px-3">
									<v-col cols="6" class="d-flex px-0">
										<div class="d-flex align-center">
											<v-btn fab color="rgb(211 242 245)" elevation="0" small class="" dark>
												<v-icon color="info">mdi-check</v-icon>
											</v-btn>
										</div>
										<div class="pr-3">
											<div class="text-h3">{{ stats.financial.totalCommission }}</div>
											<div class="text-h6 grey--text">مجموع سهم شما</div>
										</div>
									</v-col>
									<v-col cols="6" class="d-flex px-0">
										<v-btn fab color="rgb(211 242 245)" elevation="0" small class="" dark>
											<v-icon color="info">mdi-check</v-icon>
										</v-btn>
										<div class="pr-3">
											<div class="text-h3">{{ stats.financial.totalReceives }}</div>
											<div class="text-h6 grey--text">مجموع واریز شده</div>
										</div>
									</v-col>
									<v-col cols="6" class="d-flex px-0">
										<v-btn fab color="rgb(211 242 245)" elevation="0" small class="" dark>
											<v-icon color="info">mdi-check</v-icon>
										</v-btn>
										<div class="pr-3">
											<div class="text-h3">{{ stats.financial.remain }}</div>
											<div class="text-h6 grey--text">مانده تسویه نشده</div>
										</div>
									</v-col>
								</v-row>
							</div>
						</material-stat-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'MemberDashboardView',

		data: () => ({
			plans: [],
			chart: {
				type: 'Line',
				color: 'success',
				title: 'نمودار ارجاع به سایت',
				subtitle: 'نمودار ارجاع کاربر در یکسال گذشته ',
				data: {
					labels: [],
					series: [
						[],
					],
				},
				options: {
					lineSmooth,
					low: 0,
					high: 100000000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
					chartPadding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					},
					axisY: {
						offset: 90,
						labelInterpolationFnc: function (value) {
							return value.toString().toPriceFormat()
						},
					},
				},
			},
			stats: {
				register: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'success',
					icon: 'mdi-account-cash',
					subtitle: 'عملکرد',
					reffererCount: '0',
					registerCount: '0',
					userLoanCounts: '0',
					loanRequstCounts: '0',
				},
				financial: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'info',
					icon: 'mdi-cash-check',
					title: 'مالی',
					totalCommission: '0',
					totalReceives: '0',
					remain: '0',
				}
			},
			tabs: 0,
			loadingPlans: false
		}),

		computed: {
			...get('siteConfig', [
				'isCloud', 'baseUrl'
			]),
			...get('auth', [
				'getCurrentUser',
			]),
			customerCode() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer)
					return `${user.userData.customer.code}`
				return ''
			},
			commissionPercent() {
				var user = this.getCurrentUser
				return user.userData.commissionPercent
			}
		},

		mounted() {
			this.loadData()
			this.loadPlans()
		},
		methods: {
			loadPlans() {
				this.loadingPlans = true
				api.get('customermarketer/dashboard/plans', null)
					.then(response => {
						this.plans = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loadingPlans = false
					})
			},
			loadData() {
				api.get('customermarketer/dashboard/get', null)
					.then(
						response => {
							const chartData = { labels: [], series: [] }
							let high = 0
							if (response.reffererChart) {
								const series = []
								for (let i = 0; i < response.reffererChart.length; i++) {
									chartData.labels.push(response.reffererChart[i].month)
									series.push(response.reffererChart[i].amount)
									high = Math.max(high, response.reffererChart[i].amount)
								}
								chartData.series.push(series)
							}
							this.chart.data = chartData
							this.chart.options.high = high

							this.stats.register.reffererCount = response.reffererCount + ''
							this.stats.register.registerCount = response.registerCount + ''
							this.stats.register.loanRequstCounts = response.loanRequstCounts + ''
							this.stats.register.userLoanCounts = response.userLoanCounts + ''

							this.stats.financial.totalCommission = response.totalCommission.toString().toPriceFormat() + 'تومان'
							this.stats.financial.totalReceives = response.totalReceives.toString().toPriceFormat() + 'تومان'
							this.stats.financial.remain = (response.totalCommission - response.totalReceives).toString().toPriceFormat() + 'تومان'
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			copyToClipborad(plan) {
				const fallbackCopyTextToClipboard = () => {
					var el = document.createElement('textarea')
					el.value = text
					el.setAttribute('readonly', '')
					el.style = {
						position: 'absolute',
						left: '-9999px'
					}
					document.body.appendChild(el)
					el.select()
					document.execCommand('copy')
					document.body.removeChild(el)
					toast.success('لینک به حافظه کپی شد.')
				}
				var text = this.getLink(plan)
				if (!navigator.clipboard) {
					fallbackCopyTextToClipboard(text)
					return
				}
				navigator.clipboard.writeText(text).then(function () {
					toast.success('لینک به حافظه کپی شد.')
				}, function (err) {
					console.error('Async: Could not copy text: ', err)
				})
			},
			getLink(plan) {
				if (!plan)
					return `${this.baseUrl}/cl/plans/${(this.isCloud ? this.customerCode + '/' : '0/')}?mrk=` + this.getCurrentUser.userData.affiliateCode

				return `${this.baseUrl}/cl/plan/${(this.isCloud ? this.customerCode + '/' : '0/')}${plan.code}/?mrk=` + this.getCurrentUser.userData.affiliateCode
			}
		},
	}
</script>
<style>
	svg.ct-chart-bar,
	svg.ct-chart-line {
		overflow: visible;
	}
	.ct-label.ct-label.ct-horizontal.ct-end {
		position: relative;
		justify-content: flex-end;
		text-align: right;
		transform-origin: 100% 0;
		transform: translate(-100%) rotate(-45deg);
		white-space: nowrap;
	}
	.ct-label.ct-vertical.ct-start {
		white-space: pre;
		transform: translateX(-5px);
	}
</style>
